import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getAthleteRoles } from '@api/lookups';
import { IAthleteRole } from '@interfaces/lookups';

export const handleGetAthleteRoles = createAsyncThunk<AxiosResponse<IAthleteRole[]>, number>(
  'getAthleteRoles',
  getAthleteRoles,
);
